import {useHubQuery} from '../../QueryProvider'

export const useGetScheduledExports = () => {
  return useHubQuery('scheduledExports', [], {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}
